var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FlyerlineModal",
    { ref: "modal", attrs: { name: _vm.name }, on: { close: _vm.handleClose } },
    [
      _c("div", { staticClass: "sky-form" }, [
        _c(
          "div",
          { staticClass: "sky-form__row" },
          [
            _vm._l(_vm.addressTextFields, function (field) {
              return [
                _c(
                  "div",
                  { staticClass: "sky-form__columns max-w-50@medium" },
                  [
                    _c("label", { attrs: { for: _vm.p(field.name) } }, [
                      _vm._v(_vm._s(field.caption)),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields[field.name],
                          expression: "fields[field.name]",
                        },
                      ],
                      attrs: { type: "text", id: _vm.p(field.name) },
                      domProps: { value: _vm.fields[field.name] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.fields, field.name, $event.target.value)
                        },
                      },
                    }),
                  ]
                ),
              ]
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sky-form__columns max-w-50@medium" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm._f("translate")("versandaufteilungCountry")) + " "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: { readonly: "" },
                domProps: {
                  value: _vm._f("translate")(
                    "versandaufteilungCountryCtxt" + _vm.contextId
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sky-form__columns" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn--dark btn--prj-min-x w-100@until-medium float-right",
                  on: { click: _vm.confirmAddress },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("translate")("versandaufteilungConfirmNewaddress")
                    )
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }